<!--
 * @Description:
 * @Date: 2019-03-15 10:04:20
 -->
<template>
  <div class="table-box">
    <searchbar :searchEvent="searchEvent.bind(this)" :parent="this" />
    <!--列表-->
    <div>
      <el-table
        style="width: 100%"
        v-loading="loading"
        row-key="id"
        ref="recordList"
        :data="tableData"
        :stripe="false"
        :highlight-current-row="false"
        header-row-class-name="noBorder"
      >
        <!-- <el-table-column
          type="selection"
          width="55"
          row-key="id"
          :reserve-selection="true"
        ></el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="enterpriseName"
          label="企业"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectName"
          label="项目"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="customerName"
          label="药店名称"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="巡店时间"
        >
          <template slot-scope="scope">{{ scope.row.startDt }}</template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="售价(税后)"
        >
          <template slot-scope="scope">
            {{ scope.row.salesPrice | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="陈列状态"
        >
          <template slot-scope="scope">
            {{ scope.row.displayStatus | transStatus }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="是否有POP"
        >
          <template slot-scope="scope">
            {{ scope.row.isProductPop | transPop }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="stock"
          label="当日库存"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="店员是否知道卖点"
        >
          <template slot-scope="scope">
            {{ scope.row.isKnow == 1 ? '知道' : '不知道' }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="定位图片"
        >
          <template slot-scope="scope">
            <img
              :src="scope.row.addressPicUrl"
              v-amplifyImg="scope.row.addressPicUrl"
              v-if="scope.row.addressPicUrl"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="状态"
        >
          <template slot-scope="scope">
            {{ scope.row.auditGongyeStatus | transAuditStatus }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" @click="check(scope.row)">查看</el-button> -->
            <el-button
              :disabled="scope.row.auditGongyeStatus !== 1"
              type="text"
              size="small"
              @click="approve(2, scope.row)"
            >
              通过
            </el-button>
            <rejectComponent
              :disabled="scope.row.auditGongyeStatus !== 1"
              @withdraw="item => approve(3, scope.row, 0, item)"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" align="center" label="状态">
          <template slot-scope="scope">{{scope.row.auditStatus|transAuditStatus}}</template>
        </el-table-column>-->
        <!-- <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
              <el-button
              type="text"
              size="small"
              @click="check(scope.row)"
            >查看</el-button>
            <el-button
              type="text"
              size="small"
              @click="pass(scope,2)"
              :disabled="scope.row.auditStatus!=1"
            >通过</el-button>
            <el-button
              type="text"
              size="small"
              @click="pass(scope,3)"
              :disabled="scope.row.auditStatus!=1"
            >不通过</el-button>
          </template>
        </el-table-column>-->
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { otc, project, receive } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import taskRecordHandles from '@/Mixin/taskRecordHandles';
import searchbar from '@/components/Survey/searchbar';
import OpenNewWin from '@/tools/openNewWin';
import rejectComponent from '@/components/Task/components/reject.vue';
import approvalFlagMixins from '@/Mixin/approvalFlagMixins';

export default {
  mixins: [pageInation, makeSure, taskRecordHandles, approvalFlagMixins],
  data() {
    return {
      ruleForm: {}, // 用户信息
      getList: project.otcVisitPlanList, // 获取列表的AJAX
      searchQuery: {
        projectId: this.$route.query.projectId,
        taskMonth: this.$route.query.month,
        statementId: this.$route.query.statementId
      },
      searchAjax: project.crmProjectList,
      prop: {
        label: 'projectName',
        code: 'id'
      },
      extraObj: {
        type: 2
      }
    };
  },
  components: {
    dicSelect,
    searchbar,
    rejectComponent
  },
  computed: {},
  methods: {
    saveProId(val) {
      this.searchQuery.projectId = val.id;
    },
    exportEvent() {
      if (this.searchQuery.projectId && this.searchQuery.taskMonth) {
        let queryString = this.$querystring.stringify(this.searchQuery);
        window.open(project.exportOtcVisitPlanExcel + '?' + queryString);
      } else {
        this.$message.error('请选择条件');
      }
    },
    saveEnterpriseId(val) {
      //保存
      this.searchQuery.enterpriseId = val.id;
    },
    check(item) {
      this.$router.push({
        name: 'otcRecordAddEdit',
        query: {
          id: item.id
        }
      });
    },
    add() {
      this.$router.push({
        name: 'salerAdd'
      });
    },
    pass(scope, status) {
      let delEvent = scope => {
        let { $index, row } = scope;
        otc
          .updateOtcAuditStatus({
            id: row.id,
            status
          })
          .then(res => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.initWatchRouteChange();
          });
      };
      this.makeSureEvent(delEvent, scope);
    }
  },
  filters: {
    transTag(val) {
      if (val == 0) {
        return '差';
      } else if (val == 1) {
        return '一般';
      } else if (val == 2) {
        return '积极';
      } else if (val == 3) {
        return '好';
      } else if (val == 4) {
        return '很好';
      }
    },
    transStatus(val) {
      if (val == 1) {
        return '优秀';
      } else if (val == 2) {
        return '合格';
      } else if (val == 3) {
        return '不合格';
      }
    },
    transAuditStatus(val) {
      if (val == 1) {
        return '审核中';
      } else if (val == 2) {
        return '审核通过';
      } else if (val == 3) {
        return '审核未通过';
      }
    },
    transPop(val) {
      if (val == 1) {
        return '是';
      } else {
        return '否';
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
</style>
